import type { InitOptions } from 'i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const defaultLocale = 'en';

export function getDirection(locale: string) {
	return locale === 'fa' ? 'rtl' : 'ltr';
}

i18n
	.use(Backend) // Load translations using http -> /public/locales/{{lng}}/{{ns}}.json
	.use(initReactI18next)
	.init<InitOptions>({
		lng: defaultLocale,
		fallbackLng: defaultLocale,
		debug: true,
		supportedLngs: ['en', 'fa'],

		interpolation: {
			escapeValue: false, // Corrected key
		},
	})
	.catch((err) => {
		// @TODO: Remove this once we have a proper error handling
		console.error('Error initializing i18n', err);
	});

export { i18n };
